import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/icons/buildings/buildings-home-6-line/buildings-home-6-line.component.js'

const tagName = 'dap-ds-icon-home-6-line'

/**
 * `dap-ds-icon-home-6-line`
 * @summary An icon
 * @element dap-ds-icon-home-6-line
 * @title - BuildingsHome6Line
 * @group icon
 * @icontype buildings
 *
 * @attribute {number} size - (optional) The width and height in pixels
 * @attribute {boolean} selected - (optional) Sets the icon color via the `fill` attribute
 * @attribute {string} accessibilityTitle - (optional) When using the icon standalone, make it meaningful for accessibility
 * @attribute {boolean} focusable - (optional) If `true` the icon can receive focus
 *
 * @csspart base - The main icon container.
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'BuildingsHome6Line',
})

export default reactWrapper
